export type KeycloakConfig = {
  url: string;
  realm: string;
  clientId: string;
  emailClaim: string;
  userClaim: string;
};

export type KeycloakConfigResult =
  | { config: KeycloakConfig; error?: never }
  | { config?: never; error: string };

const requiredVariables = {
  REACT_APP_KEYCLOAK_URL: 'url',
  REACT_APP_KEYCLOAK_REALM: 'realm',
  REACT_APP_KEYCLOAK_CLIENT_ID: 'clientId',
  REACT_APP_KEYCLOAK_EMAIL_CLAIM: 'emailClaim',
  REACT_APP_KEYCLOAK_USER_CLAIM: 'userClaim',
} as const;

export const resolveKeycloakConfig = (
  environment: Record<string, string | undefined> = process.env
): KeycloakConfigResult => {
  const missingVariables = Object.keys(requiredVariables).filter(
    (name) => !environment[name]?.trim()
  );

  if (missingVariables.length > 0) {
    return {
      error: `Missing required Keycloak configuration: ${missingVariables.join(', ')}`,
    };
  }

  const url = environment.REACT_APP_KEYCLOAK_URL!.trim().replace(/\/+$/, '');
  try {
    const parsedUrl = new URL(url);
    if (!['http:', 'https:'].includes(parsedUrl.protocol)) {
      throw new Error('Unsupported protocol');
    }
  } catch {
    return { error: 'REACT_APP_KEYCLOAK_URL must be an absolute HTTP(S) URL.' };
  }

  return {
    config: {
      url,
      realm: environment.REACT_APP_KEYCLOAK_REALM!.trim(),
      clientId: environment.REACT_APP_KEYCLOAK_CLIENT_ID!.trim(),
      emailClaim: environment.REACT_APP_KEYCLOAK_EMAIL_CLAIM!.trim(),
      userClaim: environment.REACT_APP_KEYCLOAK_USER_CLAIM!.trim(),
    },
  };
};